import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=1cb7c3f4&scoped=true"
import script from "./ProfileUser.vue?vue&type=script&lang=js"
export * from "./ProfileUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb7c3f4",
  null
  
)

export default component.exports